import { render, staticRenderFns } from "./PackagesReportTable.vue?vue&type=template&id=77c11ee0&scoped=true"
import script from "./PackagesReportTable.vue?vue&type=script&lang=js"
export * from "./PackagesReportTable.vue?vue&type=script&lang=js"
import style0 from "./PackagesReportTable.vue?vue&type=style&index=0&id=77c11ee0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c11ee0",
  null
  
)

export default component.exports